<template>
  <div class="home-container">
    <div class="home-header">
      <div class="home-header__inner w">
        <div class="logo">
          <h1>
            <span>蓝萨智慧</span>
          </h1>
        </div>
        <div class="slogan" @click="toPage({href: 'https://service.zkhy.net'})">
          <h3>企服智脑</h3>
          <p>赋能企业智慧经营，助力企业精准决策、高效运营，迈向智能化未来。</p>
        </div>
        <div class="tabs">
          <div
            class="tab-item"
            v-for="item in tabsList"
            :class="{ active: active === item.id }"
            :key="item.id"
            @click="handleChange(item)"
          >
            <img :src="item.icon" alt="">
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="home-content">
      <div class="home-content__inner w">
        <div class="header"></div>
        <div class="title-text">
          <div class="split-line"></div>
          <span class="text">核心产品</span>
          <div class="split-line right"></div>
        </div>
        <div class="product">
          <div :id="`target${item.id}`" class="product-item" v-for="item in productList">
            <div class="product-item-wrap" @click="toPage(item)" :style="{ cursor: item.href ? 'pointer' : 'default' }">
              <div class="product-item__left">
                <img :src="item.banner" alt="">
              </div>
              <div class="product-item__right">
                <p class="title">{{ item.title }}</p>
                <p class="content" v-html="item.content"></p>
              </div>
            </div>
            <div class="bg">
              <img :src="item.bg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fyIcon from '@/assets/imgs/newHome/fy-icon.png'
import fxIcon from '@/assets/imgs/newHome/fx-icon.png'
import dyyIcon from '@/assets/imgs/newHome/dyy-icon.png'
import sjbzIcon from '@/assets/imgs/newHome/sjbz-icon.png'
import zhytjIcon from '@/assets/imgs/newHome/zhytj-icon.png'

import fyBanner from '@/assets/imgs/newHome/fy-banner.png'
import fxBanner from '@/assets/imgs/newHome/fx-banner.png'
import dyyBanner from '@/assets/imgs/newHome/dyy-banner.png'
import sjbzBanner from '@/assets/imgs/newHome/sjbz-banner.png'
import zhytBanner from '@/assets/imgs/newHome/zhytj-banner.png'

import fyBg from '@/assets/imgs/newHome/fy-opicty-bg.png'
import fxBg from '@/assets/imgs/newHome/fx-opicty-bg.png'
import dyyBg from '@/assets/imgs/newHome/dyy-opicty-bg.png'
import sjbzBg from '@/assets/imgs/newHome/sjbz-opicty-bg.png'
import zhytBg from '@/assets/imgs/newHome/zhytj-opicty-bg.png'
export default {
  name: "HomePage",
  data() {
    return {
      tabsList: [
        { id: 1 , name: '飞译平台', title: '飞译平台', href: 'https://univ.zkhy.net/', bg: fyBg, icon: fyIcon , banner: fyBanner, content: '飞译平台基于公司成熟的产品技术能力相结合，将原本面向B端客户的翻译学习方案和辅助翻译技术通过平台化的方式惠及更广泛的人群，解决翻译等领域的大众痛点问题，可针对不同领域、不同人群、不同需求的客户群提供<b>精准、实用、高效</b>的翻译结果。'},
        { id: 2 , name: '飞校平台', title: '飞校平台', href: 'https://audit.zkhy.net/', bg: fxBg, icon: fxIcon, banner: fxBanner, content: '飞校平台是公司自主研发的一款在线文档智能审校产品。利用先进的自然语言处理(NLP)、光学文字识别(OCR)、深度学习技术，打造文档一体化处理系统，核心关键功能是文本纠错提示和辅助智能写作。协助各党政机关、企事业单位自动处理<b>海量文本数据，高效审核公文、稿件，避免错误纰漏。</b>'},
        { id: 3 , name: '多语言OCR', title: '多语言OCR识别系统',href: 'https://ocrfile.zkhy.net/', bg: dyyBg, icon: dyyIcon, banner: dyyBanner, content: '系统针对垂直领域复杂场景小语种的<b>低资源、低质量、高噪音</b>等特点，采用数据合成、图像增强以及迁移学习等算法，突破低资源的限制。支持藏、维、缅甸等30个语种的图片翻译，系统支持多语言图片语种分类，多语种混合排列的复杂格式文档，可实现文档格式还原，同时可以实现多格式低质量图片文档的角度检测、图像翻转以及超分辨率增强。' },
        { id: 4 , name: '数据标注', title: '数据标注处理平台', href: 'https://anno.zkhy.net/', bg: sjbzBg, icon: sjbzIcon, banner: sjbzBanner,content: '标注平台是公司自主研发的智能化协作工具，面向图片与文本两大标注类型，已支持标注方式。平台通过项目化便捷管理、灵活配置和智能辅助算法，为用户打造高效的数据标注环境，能够快速完成标注与统计分析任务，助力各类<b>机构提升数据处理效率，提供优质服务与技术支持</b>'},
        { id: 5 , name: '智会一体机', title: '智会一体机',href: '',  bg: zhytBg, icon: zhytjIcon, banner: zhytBanner, content: '本产品利用先进的AI技术，如语音辨识、声音特征识别和自然语言处理设计出的智能语音系统。它不依赖网络，可以在本地使用。它的功能包括<b>声音特征识别、语音转文字、文本审校、声音和文字记录、音标转换以及本地化学习</b>通过这些功能，它可以快速将语音文件转换成格式化的文档，大大减少了人力成本，提高了工作效率。'},
      ],
      productList: [],
      active: ''
    }
  },
  mounted() {
    this.productList = [...this.tabsList]
  },
  methods: {
    handleChange(item) {
      document.querySelector('#target' + item.id).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    toPage(item) {
      if(item.href === '') return
      window.open(item.href, '_blank')
    }
  }
}
</script>
<style lang="scss">
</style>


<style scoped lang="scss">
p {
  margin: 0;
  padding: 0;
}
h1,h2,h3,h4,h5,h6 {
  margin: 0;
  padding: 0;
}
.home-container {
  box-sizing: border-box;
  width: 100%;
  background-color: rgba(163, 202, 255, 0.2);
  --color-primary: #0078fc;

  .w {
    max-width: 1200px;
    margin: 0 auto;
  }

  .home-header {
    box-sizing: border-box;
    display: flow-root;
    height: 420px;
    background: url("@/assets/imgs/newHome/banner.png") center center no-repeat;

    .home-header__inner {
      display: flow-root;
      position: relative;
      height: 100%;

      .logo {
        margin-top: 44px;
        width: 162px;
        height: 44px;
        background: url("@/assets/imgs/newHome/logo.png") center center no-repeat;
        background-size: 100% 100%;
        h1 {
          padding: 0;
          margin: 0;
          font-size: 0;
        }
      }
      .slogan {
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;
         h3 {
           font-size: 40px;
           margin: 0 0 32px 0;
           padding: 70px 0 0 0;
         }
        p {
          margin: 0;
          width: 450px;
          white-space: pre-wrap;
          word-break: break-all;
          font-size: 24px;
        }
      }
      .tabs {
        width: 100%;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        transform: translateY(80%);
        background-color: #fff;
        box-shadow: 0 4px 8px 0 rgba(26, 22, 23, 0.05);

        .tab-item {
          display: flex;
          align-content: center;
          padding: 20px;
          cursor: pointer;
          border-bottom: 2px solid transparent;
          text-decoration: none;
          color: #000000;
          &:hover {
            background: linear-gradient(#FFFFFF 50%, rgba(163, 202, 255, 0.3) 90%);
            border-color: var(--color-primary);
            color: var(--color-primary);
          }
          img {
            width: 40px;
            height: 34px;
            margin-right: 10px;
          }
          span {
            font-size: 24px;
          }
        }

        .active {
          background: linear-gradient(#FFFFFF 50%, rgba(163, 202, 255, 0.3) 90%);
          border-color: var(--color-primary);
          color: var(--color-primary);
        }
      }
    }
  }

  .home-content {
    padding-top: 100px;

    .home-content__inner {
      .header {
        margin-bottom: 20px;
        width: 100%;
        height: 104px;
        background: url("@/assets/imgs/newHome/header-bg.png") center center no-repeat;
      }

      .title-text {
        display: flex;
        align-content: center;
        padding: 20px 0;

        .split-line {
          flex: 1;
          background: url("@/assets/imgs/newHome/split-line-bg.png") left center no-repeat;
          background-size: 100%;
        }
        .text {
          padding: 0 28px;
          font-size: 40px;
          font-weight: bold;
        }
        .right {
          transform: rotate(180deg);
        }
      }

      .product {
        padding: 40px 0;
        .product-item {
          position: relative;
          margin-bottom: 55px;
          //background: url("@/assets/imgs/newHome/comma.png") right top no-repeat;
          &:last-child {
            margin-bottom: 0;
          }

          .bg {
            position: absolute;
            width: 133px;
            height: 113px;
            right: 0;
            bottom: 0;
          }

          .product-item-wrap {
            display: flex;
            align-items: center;
            cursor: pointer;

            .product-item__left {
              width: 500px;
              height: 260px;
              flex-shrink: 0;
              background-color: yellow;
              margin-right: 86px;
            }
            .product-item__right {
              position: relative;
              display: flex;
              flex-direction: column;
              flex: auto;

              .title {
                margin-bottom: 38px;
                font-size: 24px;
                color: var(--color-primary);
                font-weight: bold;
              }

              .content {
                font-size: 16px;
                line-height: 30px;
                color: #606266;
                text-indent: 2em;
                /deep/ b {
                  color: #303133;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
